// extracted by mini-css-extract-plugin
module.exports = {"container":"SortToggle_container__1s81N","switch":"SortToggle_switch__2-oOq"};